const prefix = '[events/round]'

export const LOAD_REQUEST = `${prefix} LOAD/REQUEST`
export const LOAD_SUCCESS = `${prefix} LOAD/SUCCESS`
export const LOAD_ERROR = `${prefix} LOAD/ERROR`
